module.exports = __webpack_public_path__ + "img/play-btn.3f1f60dd.svg";